// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1i6bT","colMin":"styles_colMin__1s8PW"};